import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { CpLoadingDesc, CpLoadingProps, CpLoadingTitle } from '../common';

const TeamMemberThumbnailSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton {
    height: 394px;
    width: 344px;
  }

  .ant-skeleton-button {
    width: 100% !important;
    height: 100% !important;
  }
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(344px, 1fr));
  gap: var(--cp-spacing-06);
  margin-top: var(--cp-spacing-06);
`;

const TeamMemberThumbnail: React.FC = () => {
  return <TeamMemberThumbnailSkeleton active shape="square" />;
};

const Grid: React.FC = () => {
  return (
    <GridWrapper>
      <TeamMemberThumbnail />
      <TeamMemberThumbnail />
      <TeamMemberThumbnail />
      <TeamMemberThumbnail />
      <TeamMemberThumbnail />
      <TeamMemberThumbnail />
    </GridWrapper>
  );
};

const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--cp-spacing-03);
`;

const TableRowSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton {
    height: 32px;
    width: 95% !important;
  }

  .ant-skeleton-button {
    width: 100% !important;
  }
  margin-bottom: var(--cp-spacing-04);
`;

const TableRow: React.FC = () => {
  return (
    <RowWrapper>
      <TableRowSkeleton active shape="square" />
      <TableRowSkeleton active shape="square" />
      <TableRowSkeleton active shape="square" />
    </RowWrapper>
  );
};

const Table: React.FC = () => {
  return (
    <div className="w-full">
      <TableRow />
      <TableRow />
      <TableRow />
      <TableRow />
      <TableRow />
      <TableRow />
    </div>
  );
};

export const CpTeamMembersLoadingSkeleton: React.FC<CpLoadingProps> = ({
  variantType,
  styles,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <CpLoadingTitle active />
      <CpLoadingDesc active />

      {variantType === CpWidgetVariantType.TeamMemberCard ? (
        <Grid />
      ) : (
        <Table />
      )}
    </CpSectionWrapper>
  );
};
